<template>
    <b-row>
        <b-col>
            <b-card class="shadow">
                <b-card-header>
                    <h3 class="mb-0 text-button text-primary">
                        Detalles Admin
                    </h3>
                </b-card-header>

                <b-card-text class="mt-5">
                    <ul class="ml-4">
                        <li> nombre: {{ this.adminData.attributes.name }}</li>
                        <li> apellido: {{ this.adminData.attributes.last_name }}</li>
                        <li> tipo doc: {{ this.adminData.attributes.document_type }}</li>
                        <li> documento: {{ this.adminData.attributes.document_number }}</li>
                        <li> celular: {{ this.adminData.attributes.phone_number }}</li>
                        <li> correo: {{ this.adminData.attributes.email }}</li>
                        <li> descripción: {{ this.adminData.attributes.description }}</li>
                        <li> estado de usuario: {{ this.adminData.attributes.user_status }}</li>
                        <li> estado de empleado: {{ this.adminData.attributes.employee_status }}</li>
                    </ul>
                </b-card-text>
            </b-card>
        </b-col>

        <b-col cols="12" lg="7" class="mt-4 mt-lg-0">
            <manage-roles 
                v-if="showRoles"
                :userId="adminData.attributes.user_id"
                role="admin"
            />
        </b-col>
    </b-row>
</template>

<script>
import { getAdmin } from '@/api/Admin/Admin'
import ManageRoles from '@/layout/Admin/ManageRoles.vue'
import swal from 'sweetalert'

export default {
    name: 'AdminsDetails',
    components: { ManageRoles},
    data: () => ({
        adminData: {
            attributes: {
                 //admin
                id: '',
                user_id: '',
                description: '',
                employee_status: '',
                //user
                name: '',
                last_name: '',
                document_type: '',
                document_number: '',
                phone_number: '',
                email: '',
                user_status: '',
            }
        },
        //
        loadingAdminData: false,
        showRoles: false
    }),
    created () {
        this.getAdminData()
    },
    methods: {
        getAdminData () {
            this.loadingAdminData = true

            getAdmin(this.$route.params.id) //IdAdmin
                .then(({data}) => {
                    console.log('admin data', data);
                    this.adminData = data.data
                    this.showRoles = true
                })
                .catch(err => {
                    console.log('err', err)
                    console.log('err.response', err.response)
                    if (err.response.status === 404) {
                        swal('404', 'Recurso no encontrado', 'warning')
                            .then(value => {
                                switch (value) {
                                    case true:
                                    case null:
                                        this.$router.push({ name: 'admin-admins-list' })
                                        break;

                                    default:
                                        console.log('adminDetails-getAdmin-swal-default-break');
                                        break;
                                }
                            })
                    }
                })
                .finally(() => {
                    this.loadingAdminData = false
                    console.log('request getAdmin end')
                })
        },
    },

}
</script>